import { getAmwayLevel, AMWAY_LEVELS } from "@/utils/kpi";
import { formatNumber } from "@/utils/format";

// Tabla de calificaciones Amway (3% – 21%) con el nivel actual resaltado.
const AmwayLevelTable = ({ pv }: { pv: number }) => {
  const current = getAmwayLevel(pv);

  return (
    <div className="glass-panel rounded-lg p-4 md:p-5">
      <div className="flex items-center gap-2 mb-1">
        <span className="w-8 h-8 rounded-md bg-primary-500/25 text-primary-100 flex items-center justify-center">
          <i className="ri-trophy-line" />
        </span>
        <h3 className="editable-title text-base font-bold">Calificación Amway</h3>
      </div>
      <p className="text-[11px] text-foreground-500 mb-4">
        Nivel alcanzado según los PV del período: compras de stock + puntos de referidos.
      </p>

      <div className="rounded-md bg-background-200/40 border border-accent-500/25 px-3 py-2 mb-4">
        <div className="flex items-center justify-between">
          <span className="text-[11px] text-foreground-500">PV del período</span>
          <span className="text-sm font-bold text-foreground-950">{formatNumber(pv)} PV</span>
        </div>
        <div className="h-1.5 rounded-full bg-background-300/40 overflow-hidden mt-2">
          <div
            className="h-full rounded-full bg-gradient-to-r from-primary-400 to-accent-500 transition-all duration-700"
            style={{ width: `${current.progress}%` }}
          />
        </div>
        <p className="text-[10px] text-foreground-500 mt-1.5">
          {current.nextMinPv
            ? `${formatNumber(Math.max(0, current.nextMinPv - pv))} PV para el nivel ${current.nextPct}%`
            : "Nivel máximo alcanzado (21%)"}
        </p>
      </div>

      <div className="space-y-1.5">
        {AMWAY_LEVELS.map((lvl) => {
          const achieved = pv >= lvl.minPv;
          return (
            <div
              key={lvl.pct}
              className={`flex items-center justify-between rounded-md px-3 py-2 text-xs ${
                achieved
                  ? "bg-accent-500/15 text-accent-200"
                  : "bg-background-200/30 text-foreground-600"
              }`}
            >
              <span className="flex items-center gap-2">
                <span className={`w-5 h-5 flex items-center justify-center rounded-full text-[10px] font-bold ${achieved ? "bg-accent-500/30" : "bg-background-300/40"}`}>
                  {achieved ? <i className="ri-check-line" /> : lvl.pct}
                </span>
                Nivel {lvl.pct}%
              </span>
              <span className="whitespace-nowrap">{formatNumber(lvl.minPv)} PV</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AmwayLevelTable;